<script>
// importing the OpenLayers stylesheet
import 'ol/ol.css'

// import axios from "axios";
import View from 'ol/View'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import {fromLonLat, transformExtent} from 'ol/proj';
import {Fill, Icon, Stroke, Style, Text,} from 'ol/style';
import CircleStyle from "ol/style/Circle";
import {Cluster, Vector as VectorSource, XYZ} from 'ol/source';
import {Attribution, defaults as defaultControls} from 'ol/control';
import {defaults as defaultInteractions} from 'ol/interaction';
import {Feature} from "ol";
import {Point} from "ol/geom";
import Select from "ol/interaction/Select";
import Geolocation from 'ol/Geolocation';
import SearchAddress from "@/SearchAddress.vue";
import { useToast } from "vue-toastification";
// OpenLayersMap.vue
import ResizeControl from './ResizeControl.js';


export default {
  components: {
    SearchAddress,
  },
  props: {
    clientId: [String, Number],
    featuresUrl: {
      type: String,
      required: true
    },
    mapSettings: {
      type: Object,
      default() {
        return {
          zoomlevel: 6,
          center: {
            lon: 5.366127,
            lat: 52.206774
          }
        }
      },
    },
    selectedFeatures: {
      type: Array,
      required: true
    },
  },
  async mounted() {
    // Get url parameters
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // Setup toast
    this.toast = useToast()

    this.features = [];

    this.headers = [
      { title: 'Stad', align: 'start', key: 'city', groupable: true },
      { title: 'Straat', align: 'end', key: 'street', groupable: true },
      { title: 'Mastnummer', align: 'end', key: 'title' },
      { title: 'Selecteren', align: 'end', key: 'action' },
    ];

    // Create static variables
    this.static = {
      source: null,
      sourceCenterPin: null,
      vectorLayer: null,
      vectorLayerCenterPin: null,
      geolocation: null,
      olView: null,
      olMap: null,
      featureStyleCache: {}, // Feature styles
      clusterStyleCache: {} // Cluster styles,
    }

    let $vm = this;

    function getText(feature) {
      return feature.get('name');
    }

    function createTextStyle(feature, fontsize, offsetY) {
      let font = fontsize+'px "Roboto", sans-serif';
      let fill = new Fill({color: '#ffffff'});
      let stroke = new Stroke({color: 'rgba(0,0,0,0.6)', width: 3});

      return new Style({
        text: new Text({
          text: getText(feature),
          font: font,
          stroke: stroke,
          fill: fill,
          offsetY: offsetY,
        })
      });
    }

    /**
     *
     * @param feature
     * @param resolution
     * @returns {Style[]}
     */
    function featureStyle(feature, resolution) {
      let fillColor = '#00962a';
      let strokeColor = '#007221';
      let strokeWidth = 2;
      let type = feature.get('type');
      let icon = 'unknown.svg';
      let iconColor = '#fff';
      let styleText = null;
      let styleOutage = null;

      // Calculate radius
      let radius = 6 / resolution
      if (radius < 6) {
        radius = 6
      }
      else if (radius > 16) {
        radius = 16
      }

      // Set the icon
      switch (type) {
        case 'lightpole':
          icon = 'lightpole.svg';
          break;
        case 'powerbox':
          icon = 'powerbox.svg';
          break;
        case 'vri':
          icon = 'vri.svg';
          break;
      }

      // Create outage style
      if (feature.get('outage_status')) {
        fillColor = '#FF0400';
        strokeColor = '#ab0400';
        // Calculate offset
        let offset = radius - 4;
        styleOutage = new Style({
          image: new Icon({
            // eslint-disable-next-line no-undef
            src: '/'+drupalSettings.path.themeUrl+'/img/map/outage-icon.png',
            displacement: [offset, offset],
            scale: 0.5,
          }),
        });
      }

      // Linear set the scale. When the radius is 8, the scale is 0.5, when the radius is 20, the scale is 1
      let iconScale = (radius - 8) / 8 * 0.5 + 0.5;

      // Set other style for selected features
      if (feature.get('selected')) {
        fillColor = '#030099';
        strokeColor = '#01004D';
        strokeWidth = 5;
      }

      // Default marker style
      let styleMarker = new Style({
        image: new CircleStyle({
          radius: radius,
          fill: new Fill({color: fillColor}),
          stroke: new Stroke({color: strokeColor, width: strokeWidth}),
        }),
      });

      // Create icon style
      let styleIcon = null;
      if (resolution < 1) {
        styleIcon = new Style({
          image: new Icon({
            // eslint-disable-next-line no-undef
            src: '/'+drupalSettings.path.themeUrl+'/img/map/'+icon,
            color: iconColor,
            scale: iconScale,
          }),
        });
      }

      // Show feature text when zoomed in
      if (resolution < 2) {
        // Calculate fontsize
        let fontsize = radius*0.8
        if (fontsize < 10) {
          fontsize = 10
        }
        // Calculate offset
        let offsetY = radius + (fontsize/2) + 3
        // Add feature text
        styleText = createTextStyle(feature, fontsize, offsetY)
      }

      // Create arrow of styles
      let styles = [];
      styles.push(styleMarker);
      if (styleIcon) {
        styles.push(styleIcon);
      }
      if (styleOutage) {
        styles.push(styleOutage);
      }
      if (styleText) {
        styles.push(styleText);
      }

      return styles;
    }


    // This hold all features
    this.static.source = new VectorSource();
    // a new vector layer is created with the feature
    this.static.vectorLayer = new VectorLayer({
      name: 'Features',
      source: this.static.source,
      minResolution: 0,
      maxResolution: 4,
      style: function (feature, resolution) {
        return featureStyle(feature, resolution);
      },
    })

    // Add cluster layer in between (is only used when the function setFeaturesClusters) is called)
    this.static.clusterSource = new Cluster({
      distance: 50,
      source: this.static.source,
      geometryFunction: function(feature) {
        // if (!$vm.isFeatureVisible(feature)) {
        //   return null;
        // }
        return feature.getGeometry();
      }
    });

    this.static.clustersLayer = new VectorLayer({
      name: 'Cluster',
      source: this.static.clusterSource,
      minResolution: 4,
      // maxResolution: 20000,
      style: function(feature) {
        let size = feature.get('features').length;
        let style = $vm.static.clusterStyleCache[size];
        if (!style) {
          style = new Style({
            image: new CircleStyle({
              radius: 16,
              fill: new Fill({
                color: '#ffffff'
              }),
              stroke: new Stroke({
                color: 'rgba(75,75,75,0.5)',
                width: 2,
              }),
            }),
            text: new Text({
              text: size.toString(),
              font: 'bold 13px "Roboto", sans-serif',
              fill: new Fill({color: '#333'})
            })
          });
          $vm.static.clusterStyleCache[size] = style;
        }
        return style;
      }
    });

    // This hold the center pin when tracking the user his location
    this.static.sourceCenterPin = new VectorSource();
    // a new vector layer is created with the feature
    this.static.vectorLayerCenterPin = new VectorLayer({
      name: 'CenterPin',
      source: this.static.sourceCenterPin,
    })

    this.static.olView = new View({
      zoom: this.mapSettings.zoomlevel,
      center: fromLonLat([this.mapSettings.center.lon, this.mapSettings.center.lat]),
      constrainResolution: true,
      maxZoom: 23,
    })

    const attribution = new Attribution({
      collapsible: true,
      collapsed: true
    });

    // Set interactions options
    let interactionOptions = {}
    // Create interactions
    let interactions = defaultInteractions(interactionOptions)

    const zoomInLabel = document.createElement('span');
    zoomInLabel.ariaLabel = 'Zoom in';
    zoomInLabel.append('+');

    const zoomOutLabel = document.createElement('span');
    zoomOutLabel.ariaLabel = 'Zoom out';
    zoomOutLabel.append('-');

    let controls = defaultControls({
      attribution: true,
    }).extend([attribution, new ResizeControl()]);

    // this is where we create the OpenLayers map
    this.static.olMap = new Map({
      // the map will be created using the 'map-root' ref
      target: this.$refs['map-root'],
      layers: [
        // adding a background tiled layer
        new TileLayer({
          source: new XYZ({
            url: "https://kaart.wemagine.nl/lms/{z}/{x}/{y}.png",
            tileSize: [256, 256],
            crossOrigin: "origin",
            maxZoom: 20,
            attributions: '<a href="https://www.openstreetmap.org/" target="_blank">© OpenStreetMap</a>',
          }),
        }),
        // the vector layer is added above the tiled OSM layer
        this.static.vectorLayer,
        this.static.clustersLayer,
        this.static.vectorLayerCenterPin,
      ],
      // Set map view
      view: this.static.olView,
      controls: controls,
      interactions: interactions,
    });


    // Set map extend if it's set
    if (this.mapSettings.mapExtend && this.mapSettings.mapExtend.length) {
      let xmin = this.mapSettings.mapExtend[0][0];
      let xmax = this.mapSettings.mapExtend[2][0];
      let ymin = this.mapSettings.mapExtend[1][1];
      let ymax = this.mapSettings.mapExtend[0][1];

      let myExtent = [xmin, ymin, xmax, ymax];
      this.static.olView.fit(myExtent , this.static.olMap.getSize());
    }

    // Go to asset when UUID is set in the URL parameter, for example: ?asset=123-456-789
    const uuid = urlParams.get('asset');
    if (uuid) {
      // Get asset data
      const assetData = await this.getAssetDataByUuid(uuid);
      if (!assetData) {
        this.toast.error("Er kon geen asset gevonden worden met de UUID: " + uuid);
      }
      // Set the ID of the feature we want to preselect, it gets preselected when adding the features. @see addFeatures()
      this.preselectedFeatureId = assetData.id;
      // Go to location on the map
      if (assetData.lon && assetData.lat) {
        // Go to coordinates on the map
        this.goToCoordinates({
          lon: assetData.lon,
          lat: assetData.lat,
        }, false);
      }
    }

    // On feature click
    const selectSingleClick = new Select({
      multi: false,
      style: function (feature, resolution) {
        return featureStyle(feature, resolution);
      },
      layers: function(layer) {
        return layer.get('name') === 'Features';
      }});
    this.static.olMap.addInteraction(selectSingleClick);
    selectSingleClick.on('select', function (e) {
      // We clear the function so all will be in selected, not deselected
      e.selected.forEach(function(feature){
        let selelected_index = $vm.selectedFeatures.findIndex(f => f.getId() == feature.getId());

        if (selelected_index < 0) {
          $vm.selectFeature(feature)
        } else {
          $vm.deselectFeature(feature)
        }
        selectSingleClick.getFeatures().clear();
      });
    });

    async function onMoveEnd() {
      // Load and add features
      await $vm.loadMapFeaturesWithinExtent();
    }
    // Add moveend listeners
    this.static.olMap.on('moveend', onMoveEnd);

    this.static.olMap.on('pointerdrag', function () {
      // Disable center on location
      $vm.geolocationRecenterOnPositionChange = false
    });

    // Load features
    await this.loadMapFeaturesWithinExtent();

    this.addAccessibilityJavascript();
  },
  data () {
    return {
      active_tab: 'map',
      geolocationRecenterOnPositionChange: false,
      loading: false,
      preselectedFeatureId: null,
      selectGroupBy: 'city',
      tableGroupBy: [
        {
          key: 'city',
          order: 'asc',
          label: 'Stad'
        }
      ],
      tableGroupByOptions: [
        {
          title: 'Plaats',
          value: 'city',
        },
        {
          title: 'Straat',
          value: 'street',
        }
      ]
    }
  },
  watch: {
    'selectedFeatures': {
      deep: true,
      handler(newValue, oldValue) {
        // Deselect all feature that are not selected anymore
        for (let i = 0; i < oldValue.length; i++) {
          let feature = this.static.source.getFeatureById(oldValue[i].getId());
          if (feature) {
            feature.set('selected', undefined);
          }
        }
        // Select newly added features
        for (let j = 0; j < newValue.length; j++) {
          let feature = this.static.source.getFeatureById(newValue[j].getId());
          if (feature) {
            feature.set('selected', true);
          }
        }
      }
    },
    selectGroupBy: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === 'street') {
            this.tableGroupBy = [
              {
                key: 'street',
                order: 'asc',
                label: 'Straat'
              }
            ];
          }
          else {
            this.tableGroupBy = [
              {
                key: 'city',
                order: 'asc',
                label: 'Stad'
              }
            ];
          }
        }
      }
    }
  },
  methods: {
    geolocationGetLocation() {
      this.geolocationRecenterOnPositionChange = true;
      // Bind geolocation when not set yet.
      if (!this.static.geoLocation) {
        // Sets up the location
        this.static.geoLocation = new Geolocation({
          trackingOptions: {
            enableHighAccuracy: true,
          },
          projection: this.static.olView.getProjection(),
          tracking: true,
        });
      }

      // Go to current geolocation
      this.geolocationCenterOnLocation()
      // Show error
      this.static.geoLocation.addEventListener('error', this.geolocationError);
      // If we don't have a position yet we set the event listener, else we'll just set the location
      this.static.geoLocation.addEventListener('change:position', this.geolocationSetLocation)
      return this;
    },
    geolocationCenterOnLocation() {
      let coordinates = this.static.geoLocation.getPosition();
      if (coordinates) {
        this.static.olView.setCenter(coordinates);
        this.static.olView.setZoom(18);
      }
    },
    geolocationSetLocation() {
      let coordinates = this.static.geoLocation.getPosition();
      if (coordinates) {
        const positionFeature = new Feature();
        positionFeature.setStyle(
          new Style({
            image: new Icon({
              // eslint-disable-next-line no-undef
              src: '/'+drupalSettings.path.themeUrl+'/img/map/geolocation.png',
              scale: 0.5,
              displacement: [0, 10],
            }),
          })
        );
        positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
        this.static.sourceCenterPin.clear() // Remove previous center pins
        this.static.sourceCenterPin.addFeature(positionFeature); // Add center pin
        // Center camera on the geolocation when flag is true
        if (this.geolocationRecenterOnPositionChange) {
          this.geolocationCenterOnLocation()
        }
      }
    },
    geolocationError() {
      this.toast.error("Locatie kon niet worden bepaald. Check of locatie in uw browser voor deze website is toegestaan.", {timeout: false});
    },
    goToCoordinates(coordinates, addMarker = true) {
      this.static.olView.setCenter(fromLonLat([coordinates.lon, coordinates.lat]))
      this.static.olView.setZoom(17);

      if (addMarker) {
        this.addCenterPin(coordinates);
      }
    },
    async getAssetDataByUuid(asset_uuid) {
      let url = new URL(import.meta.env.VITE_API_BASEURL + 'ajax/map/asset-data-by-uuid/'+asset_uuid);

      // Fetch results
      const response = await fetch(url)
      // Show error when there is something wrong
      if (!response.ok) {
        return
      }

      // Set response data
      const response_json = await response.json();

      return response_json;
    },
    async loadMapFeaturesWithinExtent() {
      this.loading = true;
      // Load features
      let features_data = await this.loadFeatures();

      this.features = features_data;
      // Add all features to the source
      if (features_data) {
        this.addFeatures(features_data);
      }

      this.loading = false;
    },
    /**
     * Load the features from the backend API.
     *
     * @returns {Promise<any>}
     */
    async loadFeatures() {
      let extent = this.static.olMap.getView().calculateExtent(this.static.olMap.getSize())
      let extentLonLat = transformExtent(extent, 'EPSG:3857', 'EPSG:4326')

      let url = new URL(import.meta.env.VITE_API_BASEURL + this.featuresUrl)
      let params = {
        "lon[min]": extentLonLat[0],
        "lat[min]": extentLonLat[1],
        "lon[max]": extentLonLat[2],
        "lat[max]": extentLonLat[3],
      }

      if (this.clientId) {
        params.client_id = this.clientId;
      }
      else if (this.static.olView.getZoom() < 12) {
        // If there's no client id set (not a visitor map) we only load when it's zoomed until big city level (whole of AMS visible)
        return;
      }

      url.search = new URLSearchParams(params).toString();

      // Fetch results
      const response = await fetch(url)
      // Show error when there is something wrong
      if (!response.ok) {
        this.toast.error("De map items konden niet geladen worden. Foutcode: [" + response.status + "] " + response.statusText, {timeout: false});
        return
      }

      const features = await response.json();
      return features;
    },
    /**
     * Add the loaded features from the backend API to the source.
     *
     * @param features_data
     */
    addFeatures(features_data) {
      let features = [];
      if (features_data && features_data.length >= 1) {
        for (const feature_data of features_data) {
          // Create new feature
          const feature = new Feature({
            geometry: new Point(fromLonLat([feature_data.longitude, feature_data.latitude])),
            name: feature_data.title,
          });
          // Add all data as a property
          feature.setProperties(feature_data);
          // Set the feature ID
          feature.setId(feature_data.id);
          // Set selected
          if (this.preselectedFeatureId && feature_data.id === this.preselectedFeatureId) {
            // Preselect the feature
            this.selectFeature(feature);
            // Make sure we don't select it multiple times
            this.preselectedFeatureId = null;
          }
          // Add feature
          features.push(feature);
        }
      }
      // Add features to source
      this.static.source.addFeatures(features);
    },
    selectFeature(feature) {
      // Emit event to parent component
      feature.set('selected', true);
      this.$emit('selectFeature', feature)
    },
    deselectFeature(feature) {
      // Emit event to parent component
      feature.set('selected', undefined);
      this.$emit('deselectFeature', feature.getId());
    },
    selectFeatureFromTable(item_id) {
      let feature_to_select = this.static.source.getFeatureById(item_id);

      if (feature_to_select) {
        this.selectFeature(feature_to_select);
      }
    },
    deselectFeatureFromTable(item_id) {
      let feature_to_select = this.static.source.getFeatureById(item_id);
      if (feature_to_select) {
        this.deselectFeature(feature_to_select);
      }
    },
    isFeatureSelected(item_id) {
      let feature = this.static.source.getFeatureById(item_id);
      let selected_index = this.selectedFeatures.findIndex(f => f.getId() == feature.getId());
      if (selected_index < 0) {
        return false;
      } else {
        return true;
      }
    },
    addAccessibilityJavascript() {
      // Find canvas element within the .map-root class
      let canvas = document.querySelector('.map-root canvas');
      if (canvas) {
        canvas.setAttribute('aria-label', 'Kaart van Nederland waarop alle lichtmasten zijn aangegeven');
        canvas.setAttribute('role', 'img');
      }

      let zoomInButton = document.querySelector('.ol-zoom .ol-zoom-in');
      if (zoomInButton) {
        zoomInButton.setAttribute('aria-label', 'Inzoomen');
      }

      let zoomOutButton = document.querySelector('.ol-zoom .ol-zoom-out');
      if (zoomOutButton) {
        zoomOutButton.setAttribute('aria-label', 'Uitzoomen');
      }
    },
    addCenterPin(coordinates) {
            const featureLocationMarker = new Feature({
        geometry: new Point(fromLonLat([coordinates.lon, coordinates.lat]))
      });

      const featureLocationMarkerStyle = new Style({
        text: new Text({
          textAlign: 'center',
          textBaseline: 'middle',
          font: '900 24px "Font Awesome 5 Pro"',
          text: '\uf3c5',
          stroke: new Stroke({color: [0, 0, 0, 1], width: 3}),
          fill: new Fill({color: '#0077FF'})
        })
      });

      featureLocationMarker.setStyle(featureLocationMarkerStyle);

      this.static.sourceCenterPin.clear();
      this.static.sourceCenterPin.addFeature(featureLocationMarker);
    }
  },
}
</script>


<template>
  <div>
    <v-tabs
      v-model="active_tab"
      class="mb-2"
    >
      <v-tab value="map">Kies op kaart</v-tab>
      <v-tab value="table">Kies in lijst</v-tab>
    </v-tabs>

    <v-tabs-window class="pt-2" v-model="active_tab">
      <v-tabs-window-item value="map">
        <search-address :client-id="clientId" @location-selected="goToCoordinates"></search-address>
        <div :class="(active_tab !== 'map') ? 'hidden' : ''">
          <div class="loader-height">
            <v-progress-linear :indeterminate="true" color="cyan" height="6" v-if="loading"></v-progress-linear>
          </div>
          <div ref="map-root" style="width: 100%; height: 50vh;" className="map-root" aria-label="LMS interactieve kaart" role="region"></div>
        </div>
      </v-tabs-window-item>

      <v-tabs-window-item value="table">

        <v-data-table
          :group-by="this.tableGroupBy"
          :headers="this.headers"
          :items="this.features"
          item-value="city"
          items-per-page="50"
          show-group-by
          disable-sort
        >
          <template v-slot:header.data-table-group="{ column }">
            <v-select
              :items="tableGroupByOptions"
              v-model="selectGroupBy"
              variant="outlined"
              label="Groepeer op"
            ></v-select>
          </template>
          <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
            <tr>
              <td :colspan="columns.length">
                <VBtn
                  :icon="isGroupOpen(item) ? '$expand' : '$next'"
                  size="small"
                  variant="text"
                  :aria-expanded="isGroupOpen(item)"
                  :aria-label="isGroupOpen(item) ? 'Inklappen ' + item.value : 'Uitklappen ' + item.value"
                  @click="toggleGroup(item)"
                ></VBtn>
                {{ item.value }}
              </td>
            </tr>
          </template>
          <template #item.action="{item}">
            <v-btn v-if="isFeatureSelected(item.id)" color="error" outlined small @click="deselectFeatureFromTable(item.id)" :aria-label="'Deselecteer ' + item.title">
              Deselecteren
            </v-btn>
            <v-btn v-else outlined error small @click="selectFeatureFromTable(item.id)" :aria-label="'Selecteer ' + item.title">
              Selecteer
            </v-btn>
          </template>
        </v-data-table>
      </v-tabs-window-item>
    </v-tabs-window>


  </div>
</template>

<style scoped>
.loader-height {
  height: 6px;
}
</style>
